export const styles = `
  * {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  span, p {
    font-size: 14px;
  }

  .font-size-inherit {
    font-size: inherit !important;
  }

  table, .table-bordered {
    width: 100%;
    border: 1px solid #efefef;
    border-collapse: collapse;
  }

  td {
    border: 1px solid #efefef;
    padding: 0.25rem;
    font-size: 14px;
  }

  .configurable-row {
    background-color: {{ client | data_get: "header_background_colour" | with_default: "#0e76bc" }};
    color: {{ client | data_get: "header_text_colour" | with_default: "#fff" }};
  }

  tbody > tr, tbody > td {
    page-break-inside: always !important;
    break-inside: always !important;
  }

  .multi-content {
    page-break-before: always !important;
    break-before: always !important;
  }

  .table-no-border {
    border: 0;
  }

  .table-no-border td {
    border: 0;
  }

  no-padding {
    padding: 0px;
  }

  .no-padding td {
    padding: 0px;
  }

  .table-bordered td  {
    border: 1px solid #efefef;
    padding: 0.25rem;
    font-size: 14px;
  }

  .document_title {
    color: {{ client | data_get: "title_text_colour" | with_default: "#0e76bc" }};
  }

  .status-row-fail {
    color: #fff;
    background-color: #ed1c24;
  }

  .status-row-pass {
    color: #fff;
    background-color: #2cb37d;
  }

  .status-row-awaiting_completion {
    color: #fff;
    background-color: #fcb040;
  }

  .status-row-not_tested {
    color: #fff;
    background-color: #fcb040;
  }

  .secondary-row-header {
    text-align: center;
    background-color: #cdcdcd;
  }

  .bg-grey {
    background-color: #cdcdcd;
  }

  .bg-yellow {
    background-color: #FFF000;
  }

  .bg-warning {
    background-color: #FCB040;
  }

  .bg-fail {
    background-color: #ED1C24;
  }

  .bg-pass {
    background-color: #2CB37D;
  }

  .bg-lightgrey {
    background-color: #eeeeee;
  }

  .bg-darkgrey {
    background-color: #808080;
  }

  .text-fail {
    color: #ED1C24;
  }

  .text-pass {
    color: #2CB37D;
  }

  .text-warning {
    color: #FCB040;
  }

  .text-yellow {
    color: #FFF000;
  }

  .text-white {
    color: #fff;
  }

  .text-bold {
    font-weight: bold;
  }

  .page-break {
    page-break-before: always;
  }

  .blank-padded-td {
    padding: 1rem;
  }

  .padded-header {
    padding: 5px;
  }

  .html-only-content {
    max-width: 1024px;
    margin: auto;
  }

  .table-padding td {
    padding: 4px;
  }

  .table-checklist-group-configured {
    border: 0px;
  }

  .table-checklist-group-configured td:nth-child(odd) {
    border-right: 1px solid #efefef;
  }

  .table-checklist-group-configured td {
    width: 50%;
  }

  .ql-align-center {
    text-align: center;
  }

  .ql-align-right {
    text-align: right;
  }

  .ql-align-justify {
    text-align: justify;
  }

  .ql-font-serif {
    font-family: 'Georgia, Times New Roman, serif';
  }

  .ql-font-monospace {
    font-family: 'Monaco, Courier New, monospace';
  }

  .ql-size-huge {
    font-size: 2.5em;
  }

  .ql-size-large {
    font-size: 1.5em;
  }

  .ql-size-small {
    font-size: 0.5em;
  }

  .d-flex {
    display: flex;
  }

  .d-flex-gap {
    gap: 0.2rem;
  }

  .align-items-center {
    align-items: center !important;
  }

  .justify-content-center {
    justify-content: center !important;
  }

  .text-center {
    text-align: center !important;
  }

  #severity_banner {
    border-radius: 0.6rem;
    padding: 14px;
    margin-bottom: 20px;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }
`;